<template>
  <div class="bim-steps" :style="{
    maxWidth: (steps.length * 120 + (steps.length - 1) * 31) + 'px'
  }">
    <div class="step__wrapper">
      <div
        v-for="(step, index) in steps"
        :key="step.name"
        class="step"
        :class="step.type"
        :style="{
          zIndex: steps.length - index
        }"
      >

        <bim-steps-icon
          :type="step.type"
          class="step__icon"
        />

        <!-- Название шага -->
        <div class="step__name mt-6">
          {{ step.name }}
        </div>

      </div>
    </div>

    <div
      v-if="info"
      class="info mt-9"
      :class="info.type"
    >

      <bim-steps-icon
        v-if="info.type"
        :type="info.type"
        class="info__icon mr-6"
      />

      <div class="info__message">
        {{ info.message }}
      </div>
    </div>
  </div>
</template>

<script>
import STEPS_ENUM from '@/components/core/bimSteps/steps.enum'
import bimStepsIcon from '@/components/core/bimSteps/bimStepsIcon'

export default {
  name: 'bimSteps',
  components: {
    bimStepsIcon
  },
  props: {
    /**
     * Массив шагов с полями:<br/><br/>
     *
     * <b>name</b> название(title) шага<br/><br/>
     *
     * <b>type</b> current | error | success | empty<br/><br/>
     */
    steps: {
      type: Array,
      required: true
    },
    /**
     * Сообщение под шагами:<br/><br/>
     *
     * <b>message</b> сообщение
     *
     * <b>type</b> current | error | success | empty<br/><br/>
     */
    info: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      STEPS_ENUM
    }
  },
  STEPS_ENUM
}
</script>

<style lang="scss" scoped>
.bim-steps {
  display: flex;
  flex-direction: column;
  width: fit-content;
}

.step__wrapper {
  display: flex;
}

.step {
  width: 120px;
  z-index: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  .step__name {
    font-size: 14px;
    letter-spacing: 0.2px;
  }

  &:not(:first-child) {
    margin-left: 31px;

    &::before {
      content: '';
      position: absolute;
      top: 10px;
      width: 110%;
      left: -70%;
      z-index: -1;
    }

    &.empty::before {
      border: 2px dashed #eeeeee;
    }

    &.error::before {
      border: 2px solid #eeeeee;
    }

    &.success::before,
    &.current::before {
      border: 2px solid #e0f4f2;
    }
  }
}

.info {
  border-radius: 5px;
  padding: 12px 14px;

  display: flex;
  align-items: center;

  background-color: #fafafa;

  .info__message {
    font-size: 14px;
    line-height: 1.57;
    letter-spacing: 0.2px;
  }

  &.error {
    .info__message {
      color: #e44545;
    }
  }

  &.success {
    background-color: #f2fbfa;
  }
}
</style>
